import ServiceTemplateSmall from './service-template-small';

export default ServiceTemplateSmall;